    <div class="tap-top" (click)=" topToTap()" [ngStyle]="{ 'display': show ? 'block' : 'none' }">
      <app-feathericon [icon]="'chevrons-up'"></app-feathericon>
    </div>
